export default "__VITE_ASSET__CGsEnivC__"